import React, { useState, useEffect }from "react";
import { Helmet } from "react-helmet";
import 'bootstrap/dist/css/bootstrap.css';
import "./Services.css";

export const Services = () => {
    const [servicesDetails, setServicesDetails] = useState([]);
    useEffect(() => {
      fetch('/services.json')
        .then(res => res.json())
        .then(data => setServicesDetails(data))
        .catch(error => console.error(error));
    }, []);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/services`;
  const description = "Browse supported game servers and launch the right plan with fast setup, flexible scaling, and a modern control panel.";
  return (
    <div className="services-page">
      <Helmet>
        <title>FlintHost | All Services</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | All Services" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | All Services" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <section className="services-hero">
        <div className="services-hero-header">
          <div>
            <p className="services-eyebrow">Supported games</p>
            <h1>Choose from our premier game selection</h1>
            <p className="services-subtitle">Start in seconds with fast setup and high-performance hardware tuned for smooth play.</p>
          </div>
        </div>
      </section>

      <section className="services-parent-container">
        <div className="services-grid">
          {servicesDetails.filter((servicesDetail) => servicesDetail.link !== "/vps").map((servicesDetail) => {
            const hasImage = Boolean(servicesDetail.image);
            return (
              <div className="services-card" key={servicesDetail.name}>
                <div className="services-card-media">
                  {hasImage ? (
                    <img src={servicesDetail.image} alt={servicesDetail.name} />
                  ) : (
                    <div className="services-card-fallback" aria-hidden="true">
                      <span>V</span>
                    </div>
                  )}
                  <div className="services-card-overlay" aria-hidden="true"></div>
                </div>
                <div className="services-card-body">
                  <h3>{servicesDetail.name}</h3>
                  <p>{servicesDetail.desc}</p>
                </div>
                <a className="services-card-cta" href={servicesDetail.link}>Order Now</a>
              </div>
            );
          })}
        </div>
      </section>

    </div>
  );
};
